<template>
  <div class="power-main">
    <div class="power-type">
      <div>岗位名称：</div>
      <div class="c-green f-bold">{{ detailData.name }}</div>
      <div class="m-l-10">
        <el-checkbox v-model="isChooseAll" @change="setToggleAll(listData)">全选</el-checkbox>
      </div>
      <div class="m-l-10">
        <el-button size="mini" type="primary" :loading="saving" @click="doSave">保存分配</el-button>
      </div>
    </div>
    <div class="power-top">
      <div class="power-group">
        <div class="power-item">一级模块</div>
        <div class="power-item">二级模块</div>
        <div class="power-item">三级模块</div>
        <div class="power-cont p-5 flex flex-x-between">功能权限</div>
      </div>
    </div>
    <div class="power-bottom">
      <!-- 一级 -->
      <div class="power-group" v-for="(itemSt, indexSt) in listData" :key="indexSt">
        <div class="power-item">
          <div class="flex flex-y-center">
            <el-checkbox :title="itemSt.key" v-model="itemSt.is_choose" @change="setToggleItem(itemSt)">
              {{ itemSt.key }}
            </el-checkbox>
          </div>
        </div>
        <div class="power-cont">
          <!-- 二级 -->
          <div class="power-group" v-for="(itemNd, indexNd) in itemSt.children" :key="indexNd">
            <div class="power-item">
              <div class="flex flex-y-center">
                <el-checkbox :title="itemNd.key" v-model="itemNd.is_choose" @change="setToggleItem(itemNd)">
                  {{ itemNd.key }}
                </el-checkbox>
              </div>
            </div>
            <div class="power-cont">
              <!-- 三级 -->
              <div class="power-group" v-for="(itemRd, indexRd) in itemNd.children" :key="indexRd">
                <div class="power-item">
                  <div class="flex flex-y-center">
                    <el-checkbox :title="itemRd.key" v-model="itemRd.is_choose" @change="setToggleItem(itemRd)">
                      {{ itemRd.key }}
                    </el-checkbox>
                  </div>
                </div>
                <div class="power-cont action-list">
                  <!-- 四级 -->
                  <div class="action-item" v-for="(itemTh, indexTh) in itemRd.children" :key="indexTh">
                    <el-checkbox :title="itemTh.key" v-model="itemTh.is_choose" @change="setToggleItem(itemTh)">
                      {{ itemTh.key }}
                    </el-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailData: {},
      listData: [],
      isChooseAll: false,
      saving: false
    }
  },
  computed: {
    id() {
      return this.$route.query.id
    }
  },
  mounted() {
    this.getDetailData()
    this.getListData()
  },
  methods: {
    // 获取岗位详情（仅用于顶部展示名称，失败不影响主流程）
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/role/editVue',
        params: { id: this.id }
      })
        .then((res) => {
          if (res.status === 200 && res.data.role) {
            this.detailData = res.data.role
          }
        })
        .catch(() => {})
    },
    // 获取权限树并按角色回显已勾选
    getListData() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/roleAssign/listTree',
        data: { role_id: Number(this.id) }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.list
          this.initChooseFromLastToFirst(result)
          this.listData = result
          this.updateChooseAll()
        }
      })
    },
    // 初始化选中-从最后到最前反推（父级勾选态由子级推导）
    initChooseFromLastToFirst(list) {
      list.forEach((item) => {
        if (item.level < 4) {
          this.initChooseFromLastToFirst(item.children)
          item.is_choose = item.children.length > 0 && item.children.every((itemNd) => itemNd.is_choose)
        } else {
          item.is_choose = !!item.is_choose
        }
      })
    },
    // 设置-切换全选
    setToggleAll(list) {
      list.forEach((item) => {
        item.is_choose = this.isChooseAll
        if (item.level < 4) this.setToggleAll(item.children)
      })
    },
    // 设置-切换项
    setToggleItem(data) {
      this.updateChooseItem(data)
      this.initChooseFromLastToFirst(this.listData)
      this.updateChooseAll()
    },
    // 更新-全选
    updateChooseAll() {
      this.isChooseAll = this.listData.length > 0 && this.listData.every((item) => item.is_choose)
    },
    // 更新-项（父级切换时联动所有子级）
    updateChooseItem(data) {
      if (data.level < 4) {
        data.children.forEach((item) => {
          item.is_choose = data.is_choose
          this.updateChooseItem(item)
        })
      }
    },
    // 收集勾选到的叶子（第四级“功能”节点）id
    collectChosenLeaves(list, out) {
      list.forEach((item) => {
        if (item.children && item.children.length) {
          this.collectChosenLeaves(item.children, out)
        } else if (item.is_choose) {
          out.push(item.id)
        }
      })
    },
    // 保存分配
    doSave() {
      let roleClassIds = []
      this.collectChosenLeaves(this.listData, roleClassIds)
      this.saving = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/roleAssign/saveAssign',
        data: {
          role_id: Number(this.id),
          role_class_ids: roleClassIds
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('保存成功')
            this.getListData()
          }
        })
        .catch(() => {})
        .then(() => {
          this.saving = false
        })
    }
  }
}
</script>

<style lang="less" scoped>
.power-main {
  .power-type {
    display: flex;
    align-items: center;
    padding: 5px;
    background: #d4e9ff;
    border: 1px solid #ddd;
  }
  .power-top {
    margin-top: -1px;
    background: #fafafa;
  }
  .power-bottom {
    margin-top: -1px;
    & > .power-group {
      &:hover {
        background: #ecf5ff;
      }
    }
    .power-item {
      &:hover {
        background: #d4e9ff;
      }
    }
  }
  .power-group {
    display: flex;
    border: 1px solid #ddd;
    & ~ .power-group {
      margin-top: -1px;
    }
    .power-item {
      display: flex;
      align-items: center;
      padding: 5px;
      width: 210px;
      border-right: 1px solid #ddd;
    }

    .power-cont {
      flex: 1;
      .power-group {
        border: none;
        & ~ .power-group {
          margin-top: 0;
          .power-item,
          .action-list {
            border-top: 1px solid #ddd;
          }
        }
      }
      &.action-list {
        display: flex;
        flex-wrap: wrap;
        .action-item {
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          padding: 5px;
          &:hover {
            background: #d4e9ff;
          }
        }
      }
    }
  }
}
</style>
